import { type ReactElement, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  maxWidth?: string
}

export function PageContainer ({ children, maxWidth }: Props): ReactElement {
  return (
    <div
      className='max-w-205 mx-auto py-8 px-7'
      style={(maxWidth != null && maxWidth !== '') ? { maxWidth } : undefined}
    >
      {children}
    </div>
  )
}
